import { css, Theme } from "@emotion/react"

export const wrapper =
    ({ expanded }: { expanded: boolean }) =>
    (theme: Theme) =>
        css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            background-color: ${theme.palette.Midnight[2]};
            height: 100%;
            ${expanded ? "width: 180px;" : "width: 64px;"}
        `

export const sidebarButtons = (theme: Theme) => css`
    width: 100%;
    margin-top: ${theme.spacing(2)};
`

export const control = (theme: Theme) => css`
    margin-bottom: ${theme.spacing(2)};
`
